import { UsersCapabilityAction, UsersCapabilityObject } from '@dock/types-dock-partner';

import { hasCapability } from '../../../services/user/hasCapability';

export const accountsBL = {
    isCreateAccountAvailable: () =>
        hasCapability(UsersCapabilityObject.ACCOUNT, UsersCapabilityAction.CREATE),
};
